import React, { useState } from 'react';

export const FilterBar = ({ onFilterChange }) => {
  const [keyword, setKeyword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilterChange({ keyword });
  };

  const handleClear = () => {
    setKeyword('');
    onFilterChange({ keyword: '' });
  };

  return (
    <div className="bg-white border-b border-slate-200 px-6 py-4">
      <form onSubmit={handleSubmit} className="flex gap-3 items-center">
        <input
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="受注No、発注No、製品CD、取引先、仕入先で検索"
          className="flex-1 px-4 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-slate-500 text-slate-900"
        />
        <button
          type="submit"
          className="px-5 py-2 bg-slate-700 text-white rounded-md hover:bg-slate-800 transition-colors font-medium"
        >
          検索
        </button>
        <button
          type="button"
          onClick={handleClear}
          className="px-5 py-2 bg-slate-100 text-slate-700 rounded-md hover:bg-slate-200 transition-colors font-medium"
        >
          クリア
        </button>
      </form>
    </div>
  );
};
